import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../app/core/services/shared.service';

@Component({
  selector: 'app-find-answers',
  templateUrl: './find-answers.component.html',
  styleUrls: ['./find-answers.component.scss']
})
export class FindAnswersComponent implements OnInit {

  constructor(private sharedService : SharedService) { }

  appsUrl = environment.CMS_APPS_URL;
  signUrl = environment.WEB_URL;

  private scrollSubscription!: Subscription;
  
  ngOnInit(): void {
     // Subscribe to the scroll position updates
     this.scrollSubscription = this.sharedService.scrollPosition$.subscribe(
      (position) => {
        // this.scrollPosition = position;
        this.onScroll();
      }
    );
  }

  sections = [
    {
      id: 1,
      preImg: "assets/icons/find-answers/slides/sliders-pre.svg",
      pre: "Customer statuses",
      title: "What are the",
      title2: "top 3 FAQ's on my website?",
      description: "Ask questions about popular FAQ's on your website and find answers instantly. Like you can ask which are the most top3 popular FAQ's on your website.",
      imageUrl: "assets/icons/find-answers/slides/find-answer-slide-1.svg"
    },
    {
      id: 2,
      preImg: "assets/icons/find-answers/slides/sliders-pre.svg",
      pre: "Customer statuses",
      title: "Which blog has",
      title2: "maximum visits on my website?",
      description: "You can ask about your blogs on your website and find instant answers. which blog has maximum views and which source got you more views.",
      imageUrl: "assets/icons/find-answers/slides/find-answer-slide-1.svg"
    },
    {
      id: 3,
      preImg: "assets/icons/find-answers/slides/sliders-pre.svg",
      pre: "Customer statuses",
      title: "What is",
      title2: "my todays todo list?",
      description: "You can ask your project management software questions like what is my todo list for today or who backlogged by over 2 days in the current sprint and find answers instantly.",
      imageUrl: "assets/icons/find-answers/slides/find-answer-slide-1.svg"
    },
    {
      id: 4,
      preImg: "assets/icons/find-answers/slides/sliders-pre.svg",
      pre: "Customer statuses",
      title: "When is your active",
      title2: "sprint getting completed",
      description: "You can ask how is my performance in the current sprint compared to last three sprints and ask Amy will answer instantly",
      imageUrl: "assets/icons/find-answers/slides/find-answer-slide-1.svg"
    },
    {
      id: 5,
      preImg: "assets/icons/find-answers/slides/sliders-pre.svg",
      pre: "Customer statuses",
      title: "Last 5 sprints",
      title2: "who are the best performers",
      description: "You can know who is who is doing well consistently or any question and your project management software answers you back.",
      imageUrl: "assets/icons/find-answers/slides/find-answer-slide-1.svg"
    }
  ];

  
  @ViewChildren('cardSection') cardRefs!: QueryList<ElementRef>;

  cardStates: { scale: number; translateY: number; opacity: number }[] = [];

  ngAfterViewInit(): void {
    this.initializeCardStates();
    this.updateCardStates();
  }
  onScroll(): void {
    this.updateCardStates();
  }

  private initializeCardStates(): void {
    this.cardStates = this.cardStates.map(() => ({
      scale: 1,
      translateY: 0,
      opacity: 1,
    }));
  }

  private updateCardStates(): void {
    const windowHeight = window.innerHeight;
    const cardRefs = this.cardRefs.toArray();

    cardRefs.forEach((cardRef, index) => {
      const element = cardRef.nativeElement;
      const rect = element.getBoundingClientRect();
      const nextCard = cardRefs[index + 1]?.nativeElement;

      let progress = 0;
      if (nextCard) {
        const nextRect = nextCard.getBoundingClientRect();
        // Calculate progress based on the next card's position
        progress = (windowHeight - nextRect.top) / windowHeight;
      }

      // Clamp progress between 0 and 1
      const clampedProgress = Math.max(0, Math.min(1, progress));

      if (clampedProgress > 0 && clampedProgress <= 1) {
        const scale = 1 - clampedProgress * 0.2;
        const translateY = clampedProgress * 50;
        const opacity = 1; // Keeping opacity constant as per your code
        this.cardStates[index] = { scale, translateY, opacity };
      } else if (clampedProgress > 1) {
        this.cardStates[index] = { scale: 0.8, translateY: 50, opacity: 1 };
      } else {
        this.cardStates[index] = { scale: 1, translateY: 0, opacity: 1 };
      }
    });
  }

}
